export default __webpack_public_path__ + "static/media/annuity.d15dadc5.svg";